/**
 * @desc create
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinAdvanceCreateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinAdvance/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
